// Mock data for Shoolin Security Services

export const companyInfo = {
  name: "Shoolin Security Services",
  tagline: "Your Safety, Our Priority",
  description: "The Leading Security and Housekeeping Service Provider in Uttarakhand",
  established: "Since 2019",
  email: "shoolinss1965@gmail.com",
  phones: ["+91-9456302658", "+91-7983760848", "+91-7906378372"],
  address: "Krishna Vihar, 11 A, Garhi Cantt Rd, Opposite RIMC Main Gate, Above Pizza Italia, Garhi Cantonment, Nimbuwala, Dehradun, Uttarakhand - 248003",
  googleMapsUrl: "https://share.google/SIE7aLFpfJThl2pqT",
  googleMapsEmbedUrl: "https://www.google.com/maps?q=Shoolin%20Security%20Services%2C%20Krishna%20Vihar%2C%2011%20A%2C%20Garhi%20Cantt%20Rd%2C%20Opposite%20RIMC%20Main%20Gate%2C%20Dehradun%2C%20Uttarakhand%20248003&output=embed",
  mission: "It is our mission to provide our clients with the kind of security they require in the most efficient and cost effective and comprehensive possible manner. Because of this Shoolin Security Services is structured and organized in such a way that highest degree of service will be provided to all its clients.",
  businessHours: {
    weekdays: "Monday – Saturday: 10:00 AM – 5:00 PM",
    sunday: "Sunday: Closed"
  }
};

export const certifications = [
  {
    id: 1,
    name: "ISO 9001:2015",
    number: "305023090641Q",
    description: "Quality Management Systems"
  },
  {
    id: 2,
    name: "MSME Registered",
    number: "UK-05-0035910",
    description: "Micro, Small & Medium Enterprises"
  },
  {
    id: 3,
    name: "PSARA Licensed",
    number: "PSA/L/69/UK/2024/JUN/1/348",
    description: "Private Security Agencies Regulation Act 2005"
  },
  {
    id: 4,
    name: "PAN",
    number: "AJWPG0570A",
    description: "Permanent Account Number"
  },
  {
    id: 5,
    name: "GST",
    number: "05AJWPG0570A1ZJ",
    description: "Goods and Services Tax Number"
  },
  {
    id: 6,
    name: "EPF",
    number: "UKDDN2498833000",
    description: "Employee Provident Fund"
  },
  {
    id: 7,
    name: "ESIC",
    number: "61000541950000999",
    description: "Employee State Insurance Corporation"
  }
];

export const services = [
  {
    id: 1,
    title: "Security Guard Force",
    description: "Guards and supervisors trained to protect employees and persons on client property. They observe irregular and unusual conditions/activities and report/correct them. Manpower is drawn from armed forces of Uttarakhand, with additional training for critical security requirements.",
    icon: "Shield",
    features: ["24/7 Protection", "Ex-Military Personnel", "Regular Reporting", "Verified Background Checks"]
  },
  {
    id: 2,
    title: "Mobile Roving Patrols",
    description: "Successful for independent monitoring of operations and services. Teams are trained to identify job deficiencies, provide on-job training, and respond to emergency situations promptly.",
    icon: "Truck",
    features: ["Regular Patrols", "Quick Response", "Area Monitoring", "Emergency Support"]
  },
  {
    id: 3,
    title: "Bodyguards & VIP Protection",
    description: "Drawn mainly from Special Services Group of Uttarakhand Army and elite force. Trained to use all available means to survive worst security hazards. Conceptual systems developed for executives, families, and high-risk profiles.",
    icon: "UserCheck",
    features: ["Elite Force Personnel", "VIP Protection", "Executive Security", "Anti-Kidnapping Measures"]
  },
  {
    id: 4,
    title: "Lady Checkers",
    description: "Specially trained female security staff who provide congenial physical security check-ups for female visitors at premises.",
    icon: "Users",
    features: ["Female Security Staff", "Professional Screening", "Privacy Maintained", "Courteous Service"]
  },
  {
    id: 5,
    title: "Security Equipment",
    description: "We deploy high-quality and advanced security equipment to ensure comprehensive protection across all client sites, including walk-through gates, safety jackets, flashlights, and traffic management tools.",
    icon: "Camera",
    features: ["Walk Through Gates", "Safety Equipment", "Communication Devices", "Traffic Control"]
  },
  {
    id: 6,
    title: "Security Escort Services",
    description: "Provided by highly trained guards with full knowledge of offensive and defensive driving techniques. Guards are geared up to face any situation.",
    icon: "Car",
    features: ["Trained Drivers", "Secure Transport", "Emergency Handling", "Defensive Driving"]
  },
  {
    id: 7,
    title: "Housekeeping Services",
    description: "Professional housekeeping and facility management services for commercial and industrial establishments, ensuring clean and maintained premises.",
    icon: "Sparkles",
    features: ["Facility Management", "Professional Staff", "Regular Maintenance", "Quality Service"]
  },
  {
    id: 8,
    title: "Wireless Communication",
    description: "Advanced wireless communication facility for real-time coordination with unlimited usage and fixed monthly charges.",
    icon: "Radio",
    features: ["Selective Calling", "Emergency Calling", "No License Required", "Unlimited Usage"]
  }
];

export const governmentClients = [
  "Excise Duty Department Dehradun",
  "Women Empowerment and Child Development Dehradun",
  "Himalayan Cultural Center Dehradun",
  "Women Institute of Technology Dehradun"
];

export const crisisManagementTeam = {
  title: "Crisis Management Team",
  description: "A specialized rapid-response unit designed to cope with emergency situations and ensure immediate action during critical incidents.",
  members: [
    "General Manager (Focal Person)",
    "Guard Supervisor",
    "Mobile Response Team (MRT) - Manpower",
    "Team Supervisor",
    "Head Guard",
    "2 to 3 Security Guards"
  ]
};

export const companyStrengths = [
  {
    id: 1,
    title: "Strategic Planning",
    description: "Supporting client mission, long-term security planning activities, and developing management initiatives for enhanced performance."
  },
  {
    id: 2,
    title: "Human Resource Management",
    description: "Recruiting skilled people and treating them as valuable assets. Matching assignments with individual talents and providing continuous professional on-job training."
  },
  {
    id: 3,
    title: "Risk Management",
    description: "Foreseeing risks and managing them to minimize dangers in the better interest of clients through proactive measures."
  },
  {
    id: 4,
    title: "Participatory Management",
    description: "Encouraging employees to participate in assessing, controlling, problem-solving, and decision-making, resulting in better solutions and enhanced productivity."
  }
];

export const trainingStandards = {
  selectionCriteria: [
    "Age: Between 21 and 55 years",
    "Physical Fitness: Medical Category 'SHAPE 1'",
    "Height: Minimum 5'6\" (relaxable for lady checkers)",
    "Chest: Minimum 32\", 2\" expansion",
    "Educational: Minimum 10th pass",
    "Verification: Character and antecedent verification mandatory",
    "Preference: Ex-servicemen, Ex-Para Military Forces, Police Personnel, Home Guards"
  ],
  trainingProgram: "Licensed Training Program as per PSARA guidelines"
};

export const employeeWelfare = [
  {
    id: 1,
    title: "EPF Registration",
    description: "Registered with Employee Provident Fund and Social Security to provide financial benefits to employees.",
    icon: "Wallet"
  },
  {
    id: 2,
    title: "ESIC Insurance",
    description: "Employee State Insurance Corporation facility to create a sense of security and health coverage.",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Medical Support",
    description: "Comprehensive medical support provided to all employees for their health and wellbeing.",
    icon: "Plus"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Ex-Service Personnel",
    description: "Our team comprises trained ex-servicemen from Indian Armed Forces and elite units.",
    icon: "Award"
  },
  {
    id: 2,
    title: "ISO 9001:2015 Certified",
    description: "Quality management systems ensuring highest standards of service delivery.",
    icon: "BadgeCheck"
  },
  {
    id: 3,
    title: "24/7 Support",
    description: "Round-the-clock crisis management team ready to respond to any emergency.",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Customized Solutions",
    description: "Tailored security solutions designed to meet your specific requirements.",
    icon: "Settings"
  },
  {
    id: 5,
    title: "PSARA Compliant",
    description: "Fully licensed and compliant with Private Security Agencies Regulation Act.",
    icon: "FileCheck"
  },
  {
    id: 6,
    title: "Local Expertise",
    description: "Strong local expertise with highly trained local security personnel.",
    icon: "MapPin"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "Facility Manager, Hotel Metropolis",
    content: "Shoolin Security Services has been instrumental in maintaining safety at our property. Their professional guards and prompt response to situations give us complete peace of mind.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    position: "Director, Tech Solutions Pvt Ltd",
    content: "We've been working with Shoolin for over 3 years. Their ex-servicemen staff brings discipline and professionalism that's unmatched in the industry.",
    rating: 5
  },
  {
    id: 3,
    name: "Vikram Singh",
    position: "Security Head, Manufacturing Unit",
    content: "The mobile patrol service and wireless communication system they provide ensures seamless security coverage across our large facility. Highly recommended!",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Essential Security Measures for Commercial Properties",
    excerpt: "Learn about the key security protocols every commercial establishment should implement to protect assets and personnel.",
    date: "2025-04-10",
    category: "Security Tips",
    image: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/sz9lvvqy_Screenshot%202026-03-02%20at%2011.52.04%E2%80%AFPM.png"
  },
  {
    id: 2,
    title: "Why Ex-Military Personnel Make the Best Security Guards",
    excerpt: "Discover the unique advantages of hiring security personnel with military background for your organization.",
    date: "2025-04-05",
    category: "Industry Insights",
    image: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/6m4lw82i_Screenshot%202026-03-02%20at%2011.52.23%E2%80%AFPM.png"
  },
  {
    id: 3,
    title: "Understanding PSARA Compliance for Security Agencies",
    excerpt: "A comprehensive guide to Private Security Agencies Regulation Act and its importance for businesses.",
    date: "2025-03-28",
    category: "Compliance",
    image: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/k0lx92di_Screenshot%202026-03-02%20at%2011.52.44%E2%80%AFPM.png"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/venej49n_Shoolin%20image%201.jpeg",
    title: "School Security Service",
    category: "Educational Institutions"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/cibr2kch_Shoolin%20image%202.jpeg",
    title: "Fire Safety Training",
    category: "Training"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/3neo5jlp_Shoolin%20image%203.jpeg",
    title: "Residential Security",
    category: "Services"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/l8lii8x3_Shoolin%20image%204.jpeg",
    title: "Facility Protection",
    category: "Commercial"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_protect-business/artifacts/brla9j3u_Shoolin%20image%205.jpeg",
    title: "Mall Security Services",
    category: "Retail"
  }
];

export const inquiryTypes = [
  "General Inquiry",
  "Security Guard Services",
  "VIP Protection",
  "Mobile Patrol Services",
  "Security Equipment",
  "Housekeeping Services",
  "Career Opportunities",
  "Partnership Inquiry"
];

export const careerBenefits = [
  {
    id: 1,
    title: "Competitive Salary",
    description: "Industry-leading compensation packages",
    icon: "DollarSign"
  },
  {
    id: 2,
    title: "Training Programs",
    description: "Continuous skill development and training",
    icon: "GraduationCap"
  },
  {
    id: 3,
    title: "Career Growth",
    description: "Clear path for advancement and promotion",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Staff Welfare",
    description: "Comprehensive welfare and support programs",
    icon: "Heart"
  }
];

